"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_REGION_CONFIG = exports.wxHost = void 0;
var file_1 = require("./file");
var wxHost;
(function (wxHost) {
    wxHost["ALPHA"] = "https://ucmp-wx-static-sit.sf-express.com";
    wxHost["PROD"] = "https://ucmp-static.sf-express.com";
})(wxHost = exports.wxHost || (exports.wxHost = {}));
exports.DEFAULT_REGION_CONFIG = (_a = {},
    // 行政区
    _a[file_1.FILE.REGION_CHN_SC] = ['region-chn-sc', '20200226'],
    // 大陆
    _a[file_1.FILE.REGION_CN_SC] = ['region-cn-sc', '20200226'],
    _a[file_1.FILE.REGION_CN_TC] = ['region-cn-tc', '20200226'],
    _a[file_1.FILE.REGION_CN_EN] = ['region-cn-en', '20200226'],
    // 香港
    _a[file_1.FILE.REGION_HK_SC] = ['region-hk-sc', '20200226'],
    _a[file_1.FILE.REGION_HK_TC] = ['region-hk-tc', '20200226'],
    _a[file_1.FILE.REGION_HK_EN] = ['region-hk-en', '20200226'],
    // 澳门
    _a[file_1.FILE.REGION_MO_SC] = ['region-mo-sc', '20200226'],
    _a[file_1.FILE.REGION_MO_TC] = ['region-mo-tc', '20200226'],
    _a[file_1.FILE.REGION_MO_EN] = ['region-mo-en', '20191013'],
    // 台湾
    _a[file_1.FILE.REGION_TW_SC] = ['region-tw-sc', '20200226'],
    _a[file_1.FILE.REGION_TW_TC] = ['region-tw-tc', '20200226'],
    _a[file_1.FILE.REGION_TW_EN] = ['region-tw-en', '20200226'],
    // 香港、澳门
    _a[file_1.FILE.REGION_HK_MO_TC] = ['region-hk-mo-tc', '20200226'],
    _a[file_1.FILE.REGION_HK_MO_EN] = ['region-hk-mo-en', '20200226'],
    // 港、澳、台
    _a[file_1.FILE.REGION_HK_MO_TW_SC] = ['region-hk-mo-tw-sc', '20200226'],
    _a[file_1.FILE.REGION_HK_MO_TW_TC] = ['region-hk-mo-tw-tc', '20200226'],
    _a[file_1.FILE.REGION_HK_MO_TW_EN] = ['region-hk-mo-tw-en', '20200226'],
    // 热门城市
    _a[file_1.FILE.HOT_CITY_CHN_SC] = ['hotcity-chn-sc', '20200225'],
    _a[file_1.FILE.HOT_CITY_CN_SC] = ['hotcity-cn-sc', '20200225'],
    _a[file_1.FILE.HOT_CITY_CN_TC] = ['hotcity-cn-tc', '20191225'],
    _a[file_1.FILE.HOT_CITY_CN_EN] = ['hotcity-cn-en', '20191225'],
    _a[file_1.FILE.HOT_CITY_HK_MO_TW_SC] = ['hotcity-hk-mo-tw-sc', '20200228'],
    _a[file_1.FILE.HOT_CITY_JP_SC] = ['hotcity-japan-sc', '20191013'],
    _a[file_1.FILE.HOT_CITY_KR_SC] = ['hotcity-korea-sc', '20191013'],
    _a[file_1.FILE.HOT_CITY_MYS_SC] = ['hotcity-mys-sc', '20191013'],
    _a[file_1.FILE.HOT_CITY_USA_SC] = ['hotcity-usa-sc', '20191013'],
    _a[file_1.FILE.IBU_HOT_COUNTIES_SC] = ['ibu-hotcounties-sc', '20191013'],
    _a[file_1.FILE.REGION_IBU_SC] = ['region-ibu-sc', '20210425'],
    _a[file_1.FILE.REGION_IBU_COUNTRY_LAT_LNG_SC] = ['region-ibu-country-lat-lng-sc', '20210425'],
    _a[file_1.FILE.REGION_JP_CITY_LAT_LNG_SC] = ['region-jp-city-lat-lng-sc', '20210425'],
    _a[file_1.FILE.REGION_KR_CITY_LAT_LNG_SC] = ['region-kr-city-lat-lng-sc', '20210425'],
    _a[file_1.FILE.REGION_MY_CITY_LAT_LNG_SC] = ['region-my-city-lat-lng-sc', '20210425'],
    _a[file_1.FILE.REGION_SG_CITY_LAT_LNG_SC] = ['region-sg-city-lat-lng-sc', '20210425'],
    _a[file_1.FILE.REGION_US_PROVINCE_LAT_LNG_SC] = ['region-us-province-lat-lng-sc', '20210425'],
    // 院校信息
    _a[file_1.FILE.COLLEGE_CN_SC] = ['college-cn-sc', '20210425'],
    _a);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/dist/common/config.js
// module id = 0SWk
// module chunks = 1